export class GetStudentGUIDApplicantTypeIDResponse {
    KxStudentGuid: string;
    ApplicationTypeID: number;
}